import { useQuery } from '@tanstack/react-query';
import { getEmailStats, listEmails, type EmailFilters } from '../lib/emailsApi';

// Email history + stats (CLE-310). Read-only admin views over the EmailLog.

const EMAILS_KEY = ['admin-emails'] as const;

export function useEmails(filters: EmailFilters = {}) {
  return useQuery({
    queryKey: [...EMAILS_KEY, filters],
    queryFn: () => listEmails(filters),
    placeholderData: (prev) => prev,
  });
}

export function useEmailStats() {
  return useQuery({
    queryKey: [...EMAILS_KEY, 'stats'],
    queryFn: () => getEmailStats(),
  });
}
